import { render, staticRenderFns } from "./ContentTypeText.vue?vue&type=template&id=84302ae4&scoped=true&"
import script from "./ContentTypeText.vue?vue&type=script&lang=js&"
export * from "./ContentTypeText.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeText.vue?vue&type=style&index=0&id=84302ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84302ae4",
  null
  
)

export default component.exports